import { gql } from "@apollo/client";

const SAVE_MANEJO_HERIDAS_VISITA_CD = gql`
mutation SaveManejoHeridasVisitaCD($input: ManejoHeridasCDInput!){
    saveManejoHeridasVisitaCD(input: $input){
        idVisitaCD
    }
}`;

export const adaptManejoHeridasCDInput = (data) => ({
  idVisita: data?.idVisita,
  manejoHeridas: !!data?.manejoHeridas,
  idComboVisitaValorTipoHerida: data?.idComboVisitaValorTipoHerida,
  otrasHeridas: data?.otrasHeridas,
  localizacion: data?.localizacion,
  idComboVisitaValorComplejidad: data?.idComboVisitaValorComplejidad,
  idComboVisitaValorComplejas: data?.idComboVisitaValorComplejas,
  indicacion: data?.indicacion,
  vac: !!data?.vac,
  presionVAC: data?.presionVAC,
  idComboVisitaValorModoVAC: data?.idComboVisitaValorModoVAC
});

export default SAVE_MANEJO_HERIDAS_VISITA_CD;